var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("TablePage", {
    attrs: { "layout-mode": _vm.layoutMode },
    scopedSlots: _vm._u(
      [
        {
          key: "search",
          fn: function () {
            return [
              (
                Array.isArray(_vm.searchSchema)
                  ? _vm.searchSchema.length > 0
                  : Object.keys(_vm.searchSchema || {}).length > 0
              )
                ? _c("SearchRenderer", {
                    attrs: {
                      query: _vm.query,
                      schema: _vm.searchSchema,
                      expanded: _vm.expanded,
                      "form-props": _vm.formProps,
                    },
                    on: {
                      "update:expanded": function ($event) {
                        _vm.expanded = $event
                      },
                      search: _vm.handleSearch,
                      reset: _vm.handleReset,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "extra",
                          fn: function (slotProps) {
                            return [
                              _vm._t("search-extra", null, null, slotProps),
                            ]
                          },
                        },
                        _vm._l(_vm.searchSlotNames, function (name) {
                          return {
                            key: name,
                            fn: function (slotProps) {
                              return [_vm._t(name, null, null, slotProps)]
                            },
                          }
                        }),
                      ],
                      null,
                      true
                    ),
                  })
                : _vm._e(),
            ]
          },
          proxy: true,
        },
        {
          key: "table-header",
          fn: function () {
            return [_vm._t("table-header")]
          },
          proxy: true,
        },
        {
          key: "table-content",
          fn: function ({ tableProps }) {
            return [
              _vm._t("table-content", null, {
                tableProps: tableProps,
                tableData: _vm.tableData,
                loading: _vm.loading,
                query: _vm.query,
              }),
              _vm.columns.length > 0
                ? _c(
                    "el-table",
                    _vm._g(
                      _vm._b(
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.loading,
                              expression: "loading",
                            },
                          ],
                          staticStyle: { width: "100%" },
                          attrs: { data: _vm.tableData },
                        },
                        "el-table",
                        { ...tableProps, ..._vm.tableAttrs },
                        false
                      ),
                      _vm.tableListeners
                    ),
                    [
                      _vm._l(_vm.columns, function (col, idx) {
                        return [
                          col &&
                          col.slot &&
                          !_vm.SPECIAL_COLUMN_TYPE.includes(col.type)
                            ? _c(
                                "el-table-column",
                                _vm._b(
                                  {
                                    key: `${
                                      col.key ||
                                      col.prop ||
                                      col.type ||
                                      col.label ||
                                      idx
                                    }-slot`,
                                    attrs: { align: col.align || "center" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _vm._t(
                                                col.slot,
                                                null,
                                                null,
                                                scope
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  "el-table-column",
                                  _vm.columnProps(col),
                                  false
                                )
                              )
                            : _c(
                                "el-table-column",
                                _vm._b(
                                  {
                                    key: `${
                                      col &&
                                      (col.key ||
                                        col.prop ||
                                        col.type ||
                                        col.label)
                                        ? col.key ||
                                          col.prop ||
                                          col.type ||
                                          col.label
                                        : idx
                                    }-plain`,
                                    attrs: { align: col.align || "center" },
                                  },
                                  "el-table-column",
                                  _vm.columnProps(col),
                                  false
                                )
                              ),
                        ]
                      }),
                    ],
                    2
                  )
                : _vm._e(),
              _vm._t("table-after", null, { query: _vm.query }),
            ]
          },
        },
        {
          key: "pagination",
          fn: function () {
            return [
              _c("Pagination", {
                attrs: { total: _vm.total, page: _vm.page, limit: _vm.limit },
                on: {
                  "update:page": function ($event) {
                    _vm.page = $event
                  },
                  "update:limit": function ($event) {
                    _vm.limit = $event
                  },
                  pagination: function ($event) {
                    return _vm.handlePagination($event)
                  },
                },
              }),
            ]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }